import React, { useState, useContext } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { LoadingContext } from '../M_Utils';

export function M_TabsInpage({ type, renderTabs, labelColor, lineBottomTabs, selectedColor, firstTabOpen, hoverSelectedColor, onGetTab }) {
    const [value, setValue] = useState(firstTabOpen ? firstTabOpen : 1)

    const ctx = useContext(LoadingContext)

    const changeTab = (event, newValue) => {
        setValue(newValue)
    }

    labelColor = labelColor ? labelColor : 'var(--color-white)'
    selectedColor = selectedColor ? selectedColor : ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)'
    hoverSelectedColor = hoverSelectedColor ? hoverSelectedColor : ctx.tertiaryColor ? ctx.tertiaryColor : 'var(--color-black)'
    lineBottomTabs = lineBottomTabs ? lineBottomTabs : ctx.tertiaryColor ? ctx.tertiaryColor : 'var(--color-grey-light)'
    return (
        <>
            <div style={{ width: '100%' }}>
                {type === "tabs" && (
                    <Tabs
                        sx={{
                            '& .MuiTabs-flexContainer': {
                                borderBottom: `2px solid ${lineBottomTabs}`,
                                height: '55px',
                            },
                            '& .MuiTab-root.Mui-selected': {
                                color: selectedColor ? selectedColor : 'var(--color-black)',
                                textTransform: 'none',
                                display: 'inherit',
                            },
                            '& .MuiTab-root': {
                                color: hoverSelectedColor,
                                textTransform: 'none',
                                display: 'inherit',
                                fontWeight: 'bold',
                            },
                            '& .MuiTabs-indicator': {
                                backgroundColor: selectedColor,
                            },
                            '& .MuiTab-iconWrapper': {
                                width: '19px',
                            },
                        }}
                        variant="scrollable"
                        scrollButtons="auto"
                        value={value}
                        onChange={changeTab}
                    >
                        {renderTabs?.map((tab, index) => (
                            <Tab
                                key={index + 1}
                                value={index + 1}
                                label={tab.labelTab}
                                icon={tab.iconTab}
                                iconPosition="start"
                                disableRipple
                                onClick={() => onGetTab(tab.labelTab, tab)}
                            />
                        ))}
                    </Tabs>
                )}

                {type === "buttons" && (
                    <div style={{ width: '100%', padding: '5px', display: 'grid', gridTemplateColumns: `repeat(${renderTabs.length}, 1fr)`, gridColumnGap: '3px' }}>
                        {renderTabs?.map((tab, index) => (
                            <div
                                style={{
                                    background: index + 1 === value ? selectedColor : hoverSelectedColor,
                                    width: '100%',
                                    borderRadius: '5px',
                                    height: '40px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    color: labelColor,
                                    fontWeight: 'bold',
                                    transition: 'background-color 0.3s',
                                    border: tab?.color ? `1px solid ${tab?.color}` : ''
                                }}
                                key={index + 1}
                                onClick={(event) => {
                                    onGetTab(tab)
                                    setValue(index + 1)
                                    event.currentTarget.style.color = labelColor
                                }}
                                onMouseEnter={(event) => {
                                    if (index + 1 !== value) {
                                        event.currentTarget.style.color = selectedColor
                                    }
                                }}
                                onMouseLeave={(event) => {
                                    if (index + 1 !== value) {
                                        event.currentTarget.style.color = labelColor
                                    }
                                }}
                            >
                                <div style={{ marginRight: '5px', width: '25px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    {tab.iconTab}
                                </div>
                                {tab.labelTab}
                            </div>
                        ))}
                    </div>
                )}
                {type === "column" && (
                    <div style={{ width: '100%', padding: '5px', borderRight: `2px solid ${ctx.primaryColor}`, }}>
                        {renderTabs?.map((tab, index) => (
                            <div
                                style={{
                                    // background: index + 1 === value ? selectedColor : hoverSelectedColor,
                                    width: '100%',
                                    borderRadius: '5px',
                                    height: '40px',
                                    display: 'flex',
                                    // justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    color: 'black',
                                    fontWeight: 'bold',
                                    transition: 'background-color 0.3s',
                                    margin: '20px'
                                }}
                                key={index + 1}
                                onClick={(event) => {
                                    onGetTab(tab)
                                    setValue(index + 1)
                                    // event.currentTarget.style.color = labelColor
                                }}
                                onMouseEnter={(event) => {
                                    if (index + 1 !== value) {
                                        event.currentTarget.childNodes[0].style.backgroundColor = hoverSelectedColor
                                        // event.currentTarget.childNodes[0].style.color = labelColor
                                    }
                                }}
                                onMouseLeave={(event) => {
                                    if (index + 1 !== value) {
                                        event.currentTarget.childNodes[0].style.backgroundColor = 'var(--color-grey)'
                                    }
                                }}
                            >
                                <div style={{
                                    marginRight: '5px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: index + 1 === value ? selectedColor : 'var(--color-grey)',
                                    color: index + 1 === value ? labelColor : 'var(--color-black)',
                                    padding: '10px',
                                    borderRadius: '25px'
                                }}>
                                    {tab.iconTab}
                                </div>
                                {tab.labelTab}
                            </div>
                        ))}
                    </div>
                )}

                {renderTabs?.map((tab, index) => (
                    <div key={index + 1} style={{ display: index + 1 === value ? 'block' : 'none', margin: '10px' }}>
                        {tab.renderBody}
                    </div>
                ))}
            </div>
        </>
    )
}
